<div class="modal-header" *ngIf="shouldShowCloseButton()">
	<button type="button" class="close" aria-label="Close" (click)="close()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>
<!-- C&C Select Invoice for Credit: dropdown + PDF viewer; each selection loads that invoice PDF -->
<div class="modal-header d-flex justify-content-between align-items-start" *ngIf="isInvoiceSelectionMode && invoiceOptions?.length > 0">
	<div class="d-flex flex-column header-left">
		<div class="d-flex justify-content-between align-items-center header-row-top">
			<h5 class="modal-title mb-0">SELECT INVOICE FOR CREDIT</h5>
			<div class="d-flex align-items-center gap-buttons-header">
				<button mat-raised-button color="btnprimary" class="margin-buttons-form-field button-success" (click)="submitSelection()" [disabled]="isSubmittingInvoice">
					<span class="button-content" *ngIf="!isSubmittingInvoice">Submit</span>
					<span *ngIf="isSubmittingInvoice" class="spinner-container">
						<span class="kt-spinner kt-spinner--center kt-spinner--sm kt-spinner--light"></span>
					</span>
				</button>
				<button type="button" class="close" aria-label="Close" (click)="close()">
					<span aria-hidden="true">&times;</span>
				</button>
			</div>
		</div>
		<div class="d-flex mt-2 align-items-center flex-wrap">
			<div class="d-flex flex-column align-items-start me-4">
				<mat-label class="mat-label">Invoice Number:</mat-label>
				<mat-form-field appearance="outline" class="small-select">
					<mat-select [(ngModel)]="selectedPdfId" (selectionChange)="loadInvoicePdfForSelection($event.value)">
						<mat-option *ngFor="let inv of invoiceOptions" [value]="inv.transactionNumber">
							{{ inv.displayText }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</div>
</div>
<!-- LON / Claim header (hidden when C&C invoice selection mode) -->
<div class="modal-header d-flex justify-content-between align-items-start" *ngIf="lonNumber !== '' && lonNumber !== undefined && lonNumber !== null && !isInvoiceSelectionMode">
	<div class="d-flex flex-column header-left">
		<div class="d-flex justify-content-between align-items-center header-row-top">
			<h5 class="modal-title mb-0" *ngIf="claimPdfHeaderTitleOverride != null && claimPdfHeaderTitleOverride !== ''">{{ claimPdfHeaderTitleOverride }}</h5>
			<h5 class="modal-title mb-0" *ngIf="claimPdfHeaderTitleOverride == null || claimPdfHeaderTitleOverride === ''">{{ isClaim ? 'Claim Number' : 'Lon Number' }}: {{ lonNumber }}</h5>
			<button type="button" class="close" aria-label="Close" (click)="close()" *ngIf="!isLonEditMode">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
		<div *ngIf="hasMultiplePdfs() && !isClaim" class="alert custom-warning-alert mt-2 text-center" role="alert">
			This LON has more than one submission.
		</div>
		<div class="d-flex mt-2" *ngIf="!isLonEditMode && !hideClaimPdfMetadata">
			<div class="d-flex flex-column align-items-start me-4">
				<mat-label class="mat-label">Sent Date: </mat-label>
				<mat-form-field appearance="outline" class="small-select">
					<mat-select [(ngModel)]="selectedPdfId" (selectionChange)="refreshPdf($event.value)">
						<mat-option *ngFor="let pdfItem of pdfList" [value]="pdfItem.id">
							{{ pdfItem.sentDate | date : "MM/dd/yyyy HH:mm:ss.SSS" }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>

			<div class="d-flex flex-column align-items-start email-column">
				<div class="d-flex flex-column">
				  <span class="small-text mb-1">Email TO:</span>
				  <span class="small-text email-list">{{ emailToList }}</span>
				</div>
				<div class="d-flex flex-column mt-2">
				  <span class="small-text mb-1">Email CC:</span>
				  <span class="small-text email-list">{{ emailCcList }}</span>
				</div>
			  </div>
		</div>
	</div>

	<div *ngIf="isLonEditMode">
		<button mat-raised-button color="btnprimary" class="margin-buttons-form-field button-success" (click)="sendEmail()">
			<span class="button-content">Send Email</span>
		</button>
		<button mat-raised-button color="btnwhite" class="margin-buttons-form-field" (click)="close()">&nbsp; Cancel &nbsp;</button>
	</div>
</div>
<div class="modal-body">
	<!-- Spinner: when no PDF (data/path) or when loading invoice PDF (C&C mode dropdown change) -->
	<div *ngIf="(!data && !path) || pdfLoadingInvoice" class="pt-5 kt-spinner kt-spinner--center kt-spinner--lg kt-spinner--dark"></div>
	<div class="pdf-viewer-controls-wrap" *ngIf="(data || path) && !pdfLoadingInvoice">
		<div class="pdf-viewer-controls row">
			<div class="pdfv-control col-4" *ngIf="renderText">
				Search:
				<input #queryInp id="pdfQueryInput" type="text" placeholder="Search..." [value]="pdfQuery" (input)="searchQueryChanged($event.target.value)" (keyup.enter)="searchQueryChanged(queryInp.value)" />
			</div>
			<div class="col-2 d-flex align-items-center justify-content-center">
				<button *ngIf="showSecondHomeButton" mat-raised-button color="btnprimary" class="second-home-btn" (click)="onSecondHomeClick()">
					<span>Second Home</span>
				</button>
			</div>
			<div class="col-2">Total Pages:{{ totalPages }}</div>
			<div class="col-4">
				<span matTooltip="Zoom Out"> <i class="fa fa-minus-square fa-lg" aria-hidden="true" (click)="zoomOut()"></i> </span>
				<span style="margin-left: 5px" matTooltip="Zoom In"> <i class="fa fa-plus-square fa-lg" aria-hidden="true" (click)="zoomIn()"></i> </span>
				<span style="margin-left: 5px" matTooltip="Rotate"> <i class="fa fa-undo fa-lg" aria-hidden="true" (click)="rotateDoc()"></i> </span>
				<span *ngIf="!isMobile" style="margin-left: 5px" matTooltip="Print"> <i class="fa fa fa-print fa-lg" aria-hidden="true" (click)="printPDF()"></i> </span>
				<span *ngIf="isMobile" style="margin-left: 5px" matTooltip="Pdf"> <i class="fa fa fa-file-pdf fa-lg" aria-hidden="true" (click)="printPDF()"></i> </span>

				<span *ngIf="invoiceNumber != undefined" style="margin-left: 5px" matTooltip="Download"><i class="fa fa-download fa-lg" aria-hidden="true" (click)="downloadPDF()"></i> </span>
			</div>
		</div>
	</div>
	<div class="pdf-viewer-viewer-window" *ngIf="(data || path) && !pdfLoadingInvoice">
		<pdf-viewer
			*ngIf="data || path"
			[src]="path"
			[downloadFileName]="name"
			[render-text]="renderText"
			[render-text-mode]="renderTextMode"
			[rotation]="rotation"
			[zoom]="zoom"
			[zoom-scale]="zoomScale"
			[original-size]="originalSize"
			[fit-to-page]="fitToPage"
			[show-all]="showAll"
			[autoresize]="autoresize"
			[download]="true"
			(after-load-complete)="callBackFn($event)"
			(error)="onError($event)"
			(on-progress)="onProgress($event)"
		></pdf-viewer>
	</div>
</div>
